export const RUNTIME_STATUS_FILTER = "runtime_status";
export const FAILED_MESSAGE = "Inputs have failed and will not receive traffic until started.";
export const SETUP_MESSAGE = "Inputs currently in setup mode will not receive traffic until started.";
export const STOPPED_MESSAGE = "Inputs currently stopped will not receive traffic until started.";
